import React from 'react';

import {
  type HighConfidenceChartAskApiResponse,
  type SampleDataChartResponse,
} from '../../../../data-layer/types';
import { CHART_VISUALIZATION } from '../../../../tests/testids';
import PlotChart from '../PlotChart/PlotChart';

import './ChartVisualization.css';

interface ChartVisualizationProps {
  data: HighConfidenceChartAskApiResponse | SampleDataChartResponse;
}

export default function ChartVisualization({ data }: ChartVisualizationProps) {
  return (
    <div data-testid={CHART_VISUALIZATION} className='Ispm-ChartVisualization'>
      <div className='Ispm-ChartVisualization-chart'>
        <PlotChart data={data} />
      </div>
    </div>
  );
}
